import { render, staticRenderFns } from "./NavUser.vue?vue&type=template&id=e97810da"
import script from "./NavUser.vue?vue&type=script&lang=js"
export * from "./NavUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports